import { TipoCampoPersonalizado } from "./enum";

export class FiltroPedidoClassificacao {
    idTabela: number;
    tipo: TipoCampoPersonalizado;
    itemSelecionado: number;
    itensSelecionados: number[];
    textoSelecionado: string;
}